// extracted by mini-css-extract-plugin
export var boxItems = "_bd-1";
export var boxItemsLg = "_bd-2";
export var button = "_bd-7";
export var buttonHoverless = "_bd-9";
export var buttonLg = "_bd-8";
export var filterGroupBox = "_bd-0";
export var icon = "_bd-3";
export var iconSecondary = "_bd-6";
export var iconWrapper = "_bd-4";
export var iconWrapperLg = "_bd-5";
export var truncatedLabel = "_bd-a";